





































































import Vue from "vue";
import loginService from "@/services/identity-authen/loginService";
import TryAnotherMethod from "./TryAnotherMethod.vue";
import SignOut from "./SignOut.vue";
import userInfoProvider from "@/services/userInfoProvider";

import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  components: {
    TryAnotherMethod,
    SignOut
  },
  props: ["buttonLabel", "useAnotherMethodText", "onReady"],
  data() {
    return {
      loading: false,
      error: "",
      message: "",
      tryAnotherMethodShown: false,
      prepareLoginResponse: null,
      prepareLogin: {} as any,
      data: {},
      mfaData: {},
      otp: "",
      sheet: false
    };
  },
  methods: {
    onReadyToSubmit(mfaData) {
      this.submit(mfaData);
    },
    async submit(mfaData) {
      try {
        const params = {
          type: this.prepareLoginResponse.type,
          request_id: this.prepareLoginResponse.request_id
        };
        for (const k in mfaData) {
          params[k] = mfaData[k];
        }

        this.loading = true;
        const { body } = await defaultDataProvider.execute("Login", {
          body: params
        });
        if (body.error_info.error_code) {
          this.error = body.error_info.message;
        } else {
          userInfoProvider.setAccessToken(body.token, this.rememberLogin);
          this.$router.push({
            path: "/login/prepare",
            query: {
              ctx: this.$route.query.ctx || ""
            }
          });
        }
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.prepareLoginResponse = loginService.getPrepareLoginResponse();
    this.prepareLogin = this.prepareLoginResponse;
    this.message = this.prepareLoginResponse.message;
    if (this.onReady) {
      this.onReady(this.prepareLoginResponse, this.onReadyToSubmit, () => {
        this.$refs.cardBasedForm.submit();
      });
    }
  }
});
